import * as React from 'react';

type ClickableTooltipTriggerProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  onTouchEnd?: React.TouchEventHandler<HTMLButtonElement>;
};

export function ClickableTooltipTrigger({
  children,
  className = '',
  onClick,
  onTouchEnd
}: ClickableTooltipTriggerProps) {
  return (
    <button
      type="button"
      className={`flex justify-center items-center border-none bg-transparent cursor-help ${className}`}
      onClick={onClick}
      onTouchEnd={onTouchEnd}>
      {children}
    </button>
  );
}
